export default __webpack_public_path__ + "static/media/cp_geo_sb.ce4d6414.svg";